import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Shipments from "./pages/Shipments";
import NewShipment from "./pages/NewShipment";
import Tracking from "./pages/Tracking";
import AddressBook from "./pages/AddressBook";
import Wallet from "./pages/Wallet";
import Billing from "./pages/Billing";
import Files from "./pages/Files";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import SmartServices from "./pages/SmartServices";
import PaymentMethods from "./pages/PaymentMethods";
import PendingApplication from "./pages/PendingApplication";
import Notifications from "./pages/Notifications";
import AdminShippingProviders from "./pages/AdminShippingProviders";
import AdminInsurance from "./pages/AdminInsurance";
import PartnerPortal from "./pages/PartnerPortal";
import Legal from "./pages/Legal";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth return synchronously (before other route logic)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard/shipments" element={<ProtectedRoute><Shipments /></ProtectedRoute>} />
      <Route path="/dashboard/shipments/new" element={<ProtectedRoute><NewShipment /></ProtectedRoute>} />
      <Route path="/dashboard/track/:bookNumber" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />
      <Route path="/dashboard/addresses" element={<ProtectedRoute><AddressBook /></ProtectedRoute>} />
      <Route path="/dashboard/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
      <Route path="/dashboard/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/dashboard/files" element={<ProtectedRoute><Files /></ProtectedRoute>} />
      <Route path="/dashboard/smart-services" element={<ProtectedRoute><SmartServices /></ProtectedRoute>} />
      <Route path="/dashboard/billing/methods" element={<ProtectedRoute><PaymentMethods /></ProtectedRoute>} />
      <Route path="/dashboard/pending" element={<ProtectedRoute><PendingApplication /></ProtectedRoute>} />
      <Route path="/dashboard/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
      <Route path="/dashboard/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/dashboard/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="/dashboard/admin/shipping" element={<ProtectedRoute adminOnly><AdminShippingProviders /></ProtectedRoute>} />
      <Route path="/dashboard/admin/insurance" element={<ProtectedRoute adminOnly><AdminInsurance /></ProtectedRoute>} />
      <Route path="/partner" element={<ProtectedRoute partnerOnly><PartnerPortal /></ProtectedRoute>} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/legal/:slug" element={<Legal />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>SellePack — Global Solutions / Protected !!</title>
        <meta name="description" content="Multi-carrier shipping platform for high-value commerce. Wallet billing, surcharge rebilling, negotiated carrier connections." />
      </Helmet>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
